import {Dialog, Button, Typography, Box, createTheme} from "@mui/material";
import { alpha } from '@mui/system';
export interface SimpleDialogProps {
  openSuccess:boolean
  handleCloseSuccess: () => void
  messagetype:string
}

const SimpleDialogSuccess = (props: SimpleDialogProps) => {

  const { openSuccess, handleCloseSuccess, messagetype } = props;

  const theme = createTheme({
        palette: {
            primary: {
                main: '#2e7d32',
              },
        },
      });
  return (
    
    <Dialog
            open={openSuccess}
            onClose={handleCloseSuccess}
          >
    
                  <Box
                  sx={{
                    width: "100%",
                    maxWidth: { xs: "100%", sm: 400 },
                    borderRadius: 2,
                    padding: { xs: 3, sm: 4 },
                  }}>
                  <Typography
                      variant="h4"
                      sx={{
                        fontSize: { xs: "1.5rem", sm: "2rem" },
                        fontWeight: 700,
                        color: theme.palette.primary.main,
                        letterSpacing: { xs: 1, sm: 2 },
                        textAlign: "center",
                        textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                      }}
                    >
                      Success
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontSize: { xs: "0.9rem", sm: "1rem" },
                        mt: { xs: 1, sm: 2 },
                        fontWeight: 300,
                        opacity: 0.9,
                        textAlign: "center",
                        textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                      }}
                    >
                    {messagetype === "Approve" ? "Success Approved" : messagetype === "Activate" ? "Update Account Success" : messagetype === "Alert" ? "Alert Update Success" : messagetype === "Successdelete" ? "Delete Succeed" : "Success Edit Account"}
                    </Typography>
                    <div className="mb-3"></div>
                    <Button
                    variant="contained"
                    onClick={handleCloseSuccess}
                    fullWidth
                    sx={{
                      padding: { xs: "10px", sm: "12px" },
                      borderRadius: { xs: "20px", sm: "25px" },
                      background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                      textTransform: "none",
                      fontWeight: 500,
                      fontSize: { xs: "1rem", sm: "1.1rem" },
                      transition: "all 0.3s ease",
                      "&:hover": {
                        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                        transform: "translateY(-2px)",
                        boxShadow: theme.shadows[4],
                      },
                      "&:focus": {
                        outline: `2px solid ${alpha(
                          theme.palette.primary.main,
                          0.5
                        )}`,
                        outlineOffset: "2px",
                      },
                    }}
                  >
                    Close
                  </Button>
                  </Box>
    
          </Dialog>
  );
};

export default SimpleDialogSuccess;
